import { unescapeGroupName } from '@/utils/fileTypeFolders'

export default {
  // The backend returns file-group names HTML-escaped (">" comes back as "&gt;").
  // Unescape the display label so folder separators render as plain ">".
  fileGroupsOptions: ({ fileGroups }) => fileGroups?.map(
    (item) => ({ label: unescapeGroupName(item.name), value: item.id, isDefault: item.default }),
  ) || [],
  fileGroupsRecord: ({ fileGroups }) => fileGroups?.reduce(
    (acc, fileGroup) => ({ ...acc, [fileGroup.id]: fileGroup }),
    {},
  ),
}
